import React from 'react';

import { RadioGroup, Radio, FormControlLabel } from '@material-ui/core';

function CustomRadio({ options, value, setValue }) {
  return (
    <div>
      <p
        style={{
          marginBottom: 0,
        }}
      >
        Possui?
      </p>
      <RadioGroup
        row
        value={value}
        onChange={({ target }) => setValue(target.value)}
      >
        {options.map((option) => (
          <FormControlLabel
            key={option}
            value={option}
            checked={value === option}
            control={<Radio />}
            label={option}
          />
        ))}
      </RadioGroup>
    </div>
  );
}

export default CustomRadio;
